import vuexStoreFactory from "@/_util/vuex-store-factory"
let factory = new vuexStoreFactory();
import config from "@/_store/modules/credentials-config"
import moment from "moment"
import jwt_decode from 'jwt-decode'

export default {
    mixins : [factory.generateMixin(config)],
    created(){
      this.credentialCacheUID++;
      return true;
    },
    data() {
        return {
          credentialCacheUID : 0,
        }
    },
    computed : {
      credentialCache : {
        get(){
          if(this.credentialCacheUID > 0)
          {
            return this.globalCredentialCache;
          }
          return {};
        },
        set(val){
           this.globalCredentialCache = val;
           this.credentialCacheUID ++;
        }
      }
    },
    methods : {
      addCredentials(id, data)
      {
        var expires_on = moment().add(data.expires_in, 'seconds').format();
        if(!id || !data || !expires_on){
          throw "This method needs the following parameters (id, data, expires_on)."
        }
        var changes = {};
        var decode = jwt_decode(data.access_token);
        changes[id] = Object.assign(data, { "$expires_on": expires_on }, { 'jwt-decode': decode }, {"logout_url": this.logout_url});
        this.credentialCache = Object.assign(this.credentialCache, changes);
        return this.getCredentials(id);
      },
      deleteCredentials(id)
      {
        var changes = {};
        changes[id] = null;
        this.credentialCache = Object.assign(this.credentialCache, changes);
      },
      getCredentials(id)
      {
        var cred = this.credentialCache[id];
        if(!!cred && moment(cred.$expires_on) < moment())
        {
          this.deleteCredentials(id);
          return null;
        }
        var cred = this.credentialCache[id];
        return cred;
      },
      clearAllCredentials()
      {
        this.credentialCache = {};
      }
    }
}